import { required } from 'vuelidate/lib/validators';

import useNotifications from '@/js/vue/_composition/useNotifications';
import useRecaptcha from '@/js/vue/_composition/useRecaptcha';

import { checkCallCenter, checkPhone } from '@/js/helpers/vueValidators';
import fieldValidation from '@/js/utils/formsVue/fieldValidation';
import pushToDataLayer from '@/js/helpers/pushToDataLayer';

import { userCheckProblem, userCallOrder } from '@/js/repositories/User';

import { ERROR_CODE_VERIFY_RECAPTCHA } from '@/js/utils/constants/constErrorsCode';

export default {
  data: () => ({
    phone: '',
    loadingProof: false,
    loading: false,
    showSuccess: false,
    needProof: false,
    policyText: 'Нажатием кнопки "Заказать звонок" Вы соглашаетесь с <a href="/pravila/" target="_blank">Пользовательским соглашением</a> и даете согласие на <a href="/politika-obrabotki-pd/" target="_blank">обработку персональных данных</a>.',
  }),
  setup() {
    return {
      ...useNotifications(),
      ...useRecaptcha(),
    };
  },
  computed: {
    isLoading() {
      return this.loading || this.loadingProof;
    },
    title() {
      return this.showSuccess ? 'Спасибо за обращение!' : 'Заказать звонок';
    },
    desc() {
      return this.showSuccess ? 'Ожидайте звонка' : 'Напишите Ваш номер телефона,<br>и мы перезвоним в течение 15 минут с 8:00-20:00 (мск)';
    },
  },
  watch: {
    needProof() {
      this.$emit('need-proof', this.needProof);
    },
  },
  validations() {
    return {
      phone: {
        required,
        checkPhone,
        checkCallCenter,
      },
    };
  },
  mounted() {
    this.recaptchaAction = 'callback';
  },
  methods: {
    fieldValidation,
    validate() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.hideNotify();
        this.loadingProof = true;

        userCheckProblem({
          phone: this.phone,
        })
          .then(({ result: { needProof: isProblem } }) => {
            this.needProof = isProblem;
            if (!isProblem) {
              this.submit();
            }
          })
          .catch((error) => {
            this.showNotify('error', error.message);
          })
          .finally(() => {
            this.loadingProof = false;
          });
      }
    },
    async submit() {
      this.loading = true;
      this.getReRecaptchaToken()
        .then((captchaToken) => {
          this.sendCallback({
            captchaToken,
            captchaAction: this.recaptchaAction,
            captchaVersion: 'rv3',
          });
        });
    },
    handlerVerified() {
      this.needProof = false;
      this.submit();
    },
    sendCallback({ captchaToken, captchaAction, captchaVersion }) {
      this.loading = true;
      this.hideNotify();

      userCallOrder({
        phone: this.phone,
        url: window.location.href,
        captchaToken,
        captchaAction,
        captchaVersion,
      })
        .then(() => {
          this.showSuccess = true;
        })
        .catch((error) => {
          if (this.recaptchaWidget !== null) {
            pushToDataLayer({ event: 'CaptchaNotVerifyAgain' });
            this.resetReCaptcha();
          }
          if (error.code && error.code === ERROR_CODE_VERIFY_RECAPTCHA) {
            if (this.recaptchaWidget === null) {
              pushToDataLayer({ event: 'CaptchaNotVerify' });
              this.renderCaptcha();
            }
          } else {
            this.showNotify('error', error.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    renderCaptcha() {
      this.renderReCaptcha((captchaToken) => {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          this.sendCallback({
            captchaToken,
            captchaAction: this.recaptchaAction,
            captchaVersion: 'rv2',
          });
        }
      });
    },
  },
};
